import React from 'react';
import { ThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import themeCustomink from './themeCustomink';
/**
 * MUI/emotion ThemeProvider wrapper, providing the 'custominkTheme' that Pigment uses. <br>
 * To use Pigment, place this provider in the root of your app.
 */
var PigmentThemeProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(ThemeProvider, { theme: themeCustomink }, children)));
};
export default PigmentThemeProvider;
//# sourceMappingURL=PigmentThemeProvider.js.map